import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import PaginationTable from '../../PaginationTable';
import {formatDatetime, formatFloat, numberPadding } from '../../../../utils/formatting';


export default class AccompanimentDirector extends React.Component {

    constructor(props) {
        super(props);
        this.showDetail = this._showDetail.bind(this);
        this.hideDetail = this._hideDetail.bind(this);
        this.state = {
            showDetailFor : null
        }
    }

    _showDetail(report) {
        this.setState({
            showDetailFor : report,
        });
    }

    _hideDetail() {
        this.setState({
            showDetailFor : null,
        });
    }


    render() {
        const report = this.state.showDetailFor;
        return (
            <div className="table-responsive">
                <PaginationTable
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    {...this.props.data}
                    showDetail={this.showDetail}
                    pageChange={this.props.changePage}
                    headerComponent={renderHeader}
                    rowComponent={renderRow}/>

                <Modal isOpen={report !== null} toggle={this.hideDetail} bsSize="large">
                    <ModalHeader toggle={this.hideDetail}>
                        Detalle
                    </ModalHeader>
                    <ModalBody>
                        {
                            report !== null ?
                            <table className="table">
                                <tbody>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            1. Principales clientes PyME
                                        </th>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            <small>1.1 Cartera Crédito PyME</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuál es el estatus de cartera de crédito (real vs meta)
                                        </td>
                                        <td>
                                            {report.credito_cifras}
                                        </td>
                                        <td>
                                            {report.credito_comments}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cúal es la estrategia para cubrir gaps?
                                        </td>
                                        <td colSpan={2}>
                                            {report.estrategia_gaps_cred}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se requiere algún apoyo para alcanzar la meta?
                                        </td>
                                        <td colSpan={2}>
                                            {report.apoyo_alcanzar}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            <small>1.2 Captación de clientes PyME</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            Revisión de principales clientes PyME que salieron de la cartera
                                        </td>
                                        <td>
                                            {report.clientes_fuera}
                                        </td>
                                        <td>
                                            {formatFloat(report.clientes_fuera_monto)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se tiene alguna estratégia para cerrar el gap?
                                        </td>
                                        <td colSpan={2}>
                                            {report.estrategia_gaps_fuera}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se requiere algún apoyo para recuperar montos perdidos?
                                        </td>
                                        <td colSpan={2}>
                                            {report.apoyo_recuperar}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            2. Seguimiento de campaña de crédito
                                        </th>
                                    </tr>
                                    
                                    <tr>
                                        <td>
                                            ¿Cuántos prospectos tienes y cuáles son los montos?
                                        </td>
                                        <td>
                                            {report.seg_prospectos}
                                        </td>
                                        <td>
                                            {formatFloat(report.seg_prospectos_monto)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            ¿Cuántos prospectos haz contratado? (% de conversión)
                                        </td>
                                        <td>
                                            {report.seg_contrato}
                                        </td>
                                        <td>
                                            {formatFloat(report.seg_contrato_monto)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            ¿Cúal es la estrategia para colocar el restante?
                                        </td>
                                        <td colSpan={2}>
                                            {report.estrategia_gaps_rest}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            : null
                        }
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>Fecha</th>
            <th>Título cita</th>
            <th>Número empleado</th>
            <th>Director de sucursal</th>
            <th>Detalle</th>
        </tr>
    );
}

function renderRow(props) {
    const {item} = props;
    return (
        <tr>
            <td>
                {formatDatetime(item.event.datetime)}
            </td>
            <td>
                {item.event.title}
            </td>
            <td>
                {numberPadding(item.event.target.emp_number, 6)}
            </td>
            <td>
                {item.event.target.name}
            </td>
            <td>
                <button className="btn btn-sm btn-primary" onClick={() => props.showDetail(item)}>Detalle</button>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/accompaniment/AccompanimentDirector.jsx
 **/